<template>
	<tr>
		<!-- {{wishlistItem}} -->
		<td>
			<div class="cart-anchor-image">
				<router-link
					:to="{
						name: 'ProductDetail',
						params: {id: wishlistItem.product.id, slug : wishlistItem.product.product_slug},
					}"
				>
					<img
						:src="getImagePath(wishlistItem.combination.image.path)"
						@error="$event.target.src = 'https://fl-1.cdn.flockler.com/embed/not-found.png'"
						:alt="wishlistItem.combination.image.name"
					/>
					<h6>
						{{ wishlistItem.product.product_name }} -
						{{
							wishlistItem.combination.attribute_variations.length
								? wishlistItem.combination.attribute_variations[0].variation.name
								: ""
						}}
					</h6>
				</router-link>
			</div>
		</td>
		<td>
			<div class="cart-price">{{ wishlistItem.warehouse_name }}</div>
		</td>
		<td>
			<div class="cart-price">{{formatCurrency(wishlistItem.product.lowest_price) }}</div>
		</td>
		<td>
			<div class="cart-stock">In Stock</div>
		</td>
		<td>
			<div class="action-wrapper">
				<button
					class="button button-outline-secondary fas fa-shopping-cart"
					@click="
						() =>
							moveWishlistToCart({
								wishlist_id: wishlistItem.id,
								warehouse_id: wishlistItem.warehouse_id,
							})
					"
				></button>
				<button
					class="button button-outline-secondary fas fa-trash"
					@click="() => deleteProductFromWishlist(wishlistItem.id)"
				></button>
			</div>
		</td>
	</tr>
</template>

<script>
	import {publicPath} from "../../../vue.config";
	import {mapGetters, mapActions} from "vuex";
	import {formatCurrency} from "../../utils/common_functions"
	export default {
		props: ["wishlistItem"],
		methods: {
			...mapActions("wishlist", ["deleteProductFromWishlist", "moveWishlistToCart"]),
			getImagePath(path) {
				return this.API_URL + path;
			},
			formatCurrency,
		},
		data() {
			return {
				publicPath: publicPath,
				API_URL: process.env.VUE_APP_API_URL,
			};
		},
		mounted() {
			// console.log(this.wishlistItem);
		},
	};
</script>

<style></style>
